module.exports = __webpack_public_path__ + "img/pipedrive.523c0af8.png";